import React from 'react';
import { HAA, GS, GBI, CONTOSO, LPM } from '../../../constants/Brokers';
import { ReactComponent as Hamburger } from '../../../assets/images/svg/hamburger.svg';
import { ReactComponent as User } from '../../../assets/images/svg/user-icon.svg';
import { ReactComponent as Close } from '../../../assets/images/svg/close.svg';
import themeColors from '../../../assets/styles/themeColors';
/* *********************************************************** 
****** NOTE to developers: ***********************************
****** DO NOT DELETE the commented template. *****************
****** Use this template to create your own function. ********
==============================================================
export const getHeaderHamburgerIcon = (brokerTheme) => {
  switch (brokerTheme) {
    case HAA:
      break;
    case GS:
      break;
    case LPM:
      break;
    case CONTOSO:
      break;
    default:
  }
};
 *********************************************************** */

export const HamburgerIcon = (brokerTheme) => {
  switch (brokerTheme) {
    case GS:
      return () => <Hamburger style={{ color: themeColors.colorFooterText }} />;
    case HAA:
      return () => (
        <Hamburger style={{ color: themeColors.colorMainHeaderBackground }} />
      );
    case GBI:
    case LPM:
    case CONTOSO:
    default:
      return () => <Hamburger />;
  }
};

export const UserIcon = (brokerTheme) => {
  switch (brokerTheme) {
    case GS:
      return () => <User style={{ color: themeColors.colorFooterText }} />;
    case HAA:
      return () => (
        <User style={{ color: themeColors.colorMainHeaderBackground }} />
      );
    case LPM:
    case CONTOSO:
    default:
      return () => <User />;
  }
};

export const CloseIcon = (brokerTheme) => {
  switch (brokerTheme) {
    case GS:
      return () => <Close style={{ color: themeColors.colorFooterText }} />;
    case HAA:
      return () => (
        <Close style={{ color: themeColors.colorMainHeaderBackground }} />
      );
    case LPM:
    case CONTOSO:
    default:
      return () => <Close />;
  }
};
